import { render, staticRenderFns } from "./SalesPrediction.vue?vue&type=template&id=258ba56f"
import script from "./SalesPrediction.vue?vue&type=script&lang=js"
export * from "./SalesPrediction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports